module.exports=function(scope){ return `<li id="${scope.id}" class="asseco-toolbar-floaty-list-item">
    ${scope.icon}
</li>`};